import { ProblemError } from "@cosmosai/api-client";
import type { TFunction } from "i18next";
import { describeError } from "../../ui/error-state";

/** The platform's codes this feature explains in the interface's language. */
const KNOWN = new Set([
  "document.too-large",
  "document.unsupported-type",
  "document.deleting",
  "document.not-found",
  "storage.not-ready",
  "kb.not-found",
]);

/** A refusal in words: the code's sentence when known, else the problem's title and detail. */
export function problemText(t: TFunction, error: unknown): string {
  const code = error instanceof ProblemError ? error.code : undefined;
  if (code && KNOWN.has(code)) return t(`knowledge.problems.${code.replaceAll(".", "_")}`);
  const { title, detail } = describeError(error, t("ui.error.title"));
  return detail ? `${title}: ${detail}` : title;
}
